import { colors } from "../../../../../theme/tokens/variables";
import LinkIcon from "./icons/LinkIcon";

const HTTPTask = ({ nodeData }: any) => {
  const mode = "dark";
  const darkMode = mode === "dark";

  const { task } = nodeData;
  const {
    inputParameters: { http_request: request },
  } = task;

  const method = request?.method
    ? request?.method
    : task?.inputParameters?.method;

  const uri = request?.uri ? request?.uri : task?.inputParameters?.uri;

  return (
    <div style={{ marginTop: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        <div style={{ marginRight: "10px", flexShrink: 0 }}>
          <LinkIcon />
        </div>
        <div
          style={{
            fontSize: "0.8em",
            padding: "4px 8px",
            color: darkMode ? colors.gray14 : colors.gray01,
            background: darkMode ? colors.gray06 : colors.gray12,
            borderRadius: "5px",
            height: "fit-content",
          }}
        >
          {method}
        </div>
        <div
          style={{
            padding: "0 8px",
            lineHeight: "2em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "keep-all",
            whiteSpace: "nowrap",
          }}
        >
          {method === "GET" ? (
            <a
              href={uri}
              style={{ textDecoration: "none", color: "inherit" }}
              target="_blank"
              rel="noreferrer"
            >
              {uri}
            </a>
          ) : (
            uri
          )}
        </div>
      </div>
    </div>
  );
};

export default HTTPTask;
